import ApiService from "../ApiService";

export default class InvoiceService {
  static getListBank = async (params) => {
    const instance = await ApiService();
    return instance
      .get(`/payment/banks`)
      .then((response) => {
        let data = response.data.map((row) => {
          return {
            can_disburse: row.can_disburse,
            bank_code: row.code,
            bank_name: row.name,
          };
        });
        data = data.filter((row) => {
          return row.can_disburse
        })
        // Filter
        if (params && params.keyword && params.keyword !== "") {
          let filteredData = [];
          data.map((row) => {
            if (row.bank_code !== "" && row.bank_name !== "") {
              let keyword = params.keyword.toString().toLowerCase();
              const match =
                row.bank_code.toString().toLowerCase().indexOf(keyword) > -1 ||
                row.bank_name.toString().toLowerCase().indexOf(keyword) > -1;
              if (match) {
                filteredData.push({
                  bank_code: row.bank_code,
                  bank_name: row.bank_name,
                });
              }
            }
          });
          return filteredData;
        }

        return data;
      })
      .catch((error) => {
        return error;
      });
  };

  static getInvoiceList = async (params) => {
    let status, settled, date_start, date_end, num, cursor;

    if (params.status && params.status !== "") {
      status = `&status=${params.status}`;
    }

    if (params.settled && params.settled !== "") {
      settled = `&settled=${params.settled}`;
    }

    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }

    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    if (params.num && params.num !== "") {
      num = `?num=${params.num}`;
    } else {
      num = `?num=20`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/invoice${num}${status || ""}${settled || ""}${date_start || ""}${
        date_end || ""
      }${cursor || ""}`
    );
  };

  static getInvoiceOrderList = async (params) => {
    let unlimited, progress, sort, num, cursor;

    if (params.progress && params.progress !== "") {
      progress = `&progress=${params.progress}`;
    }

    if (params.sort && params.sort !== "") {
      sort = `&sort=${params.sort}`;
    }

    if (params.unlimited && params.unlimited !== "") {
      unlimited = `&unlimited=${params.unlimited}`;
    }

    if (params.num && params.num !== "") {
      num = `?num=${params.num}`;
    } else {
      num = `?num=20`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/invoice/transaction/order${num}${progress || ""}${sort || ""}${
        unlimited || ""
      }${cursor || ""}`
    );
  };

  static getInvoiceSummary = async (params) => {
    let status, settled, date_start, date_end;

    if (params.status && params.status !== "") {
      status = `&status=${params.status}`;
    }

    if (params.settled && params.settled !== "") {
      settled = `&settled=${params.settled}`;
    }

    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }

    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/invoice/summary?${status || ""}${settled || ""}${date_start || ""}${
        date_end || ""
      }`
    );
  };

  static getInvoiceReconciliation = async (id) => {
    const instance = await ApiService();
    return instance.get(`/invoice/reconciliation/${id}`);
  };

  static bulkupdateInvoice = async (params) => {
    const instance = await ApiService();
    return instance.post(`/invoice/settled/bulk_update`, params);
  };

  static patchInvoiceSettled = async (id, params) => {
    const instance = await ApiService();
    return instance.patch(`/invoice/settled/${id}`, params);
  };

  static downloadInvoice = async (params) => {
    let status, settled, date_start, date_end;

    if (params.status && params.status !== "") {
      status = `&status=${params.status}`;
    }

    if (params.settled && params.settled !== "") {
      settled = `&settled=${params.settled}`;
    }

    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }

    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/invoice/download?${status || ""}${settled || ""}${date_start || ""}${
        date_end || ""
      }`
    );
  };

  static getTotalSaldo = async () => {
    const instance = await ApiService();
    return instance.get(`/invoice/transaction/order/saldo`);
  };

  static getInvoiceHistoryList = async (params) => {
    let external_id, status, trx_date_start, trx_date_end, num, cursor;

    if (params.external_id && params.external_id !== "") {
      external_id = `&external_id=${params.external_id}`;
    }

    if (params.status && params.status !== "") {
      status = `&status=${params.status}`;
    }

    if (params.trx_date_start && params.trx_date_start !== "") {
      trx_date_start = `&trx_date_start=${params.trx_date_start}`;
    }

    if (params.trx_date_end && params.trx_date_end !== "") {
      trx_date_end = `&trx_date_end=${params.trx_date_end}`;
    }

    if (params.num && params.num !== "") {
      num = `?num=${params.num}`;
    } else {
      num = `?num=20`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/invoice/history${num}${external_id || ""}${status || ""}${
        trx_date_start || ""
      }${trx_date_end || ""}${cursor || ""}`
    );
  };

  static storeInvoiceBilling = async (params) => {
    const instance = await ApiService();
    return instance.post(`/invoice/billing`, params);
  };

  static getInvoiceBillingList = async (params) => {
    let progress, date_start, date_end;

    progress = `?progress=`;

    if (params.progress && params.progress !== "") {
      progress = `?progress=${params.progress}`;
    }

    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }

    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/invoice/billing${progress}${date_start || ""}${date_end || ""}`
    );
  };

  static createBatchDisbursement = async (params) => {
    const instance = await ApiService();
    return instance.post(`/disbursement/batch`, params);
  };

  static deleteBillingInvoice = async (id) => {
    const instance = await ApiService();
    return instance.delete(`/invoice/billing/${id}`);
  };
}
